(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const formatterCache = new Map();

  function getCountElements() {
    return Array.from(document.querySelectorAll('[data-cart-count], [data-mobile-cart-count]'));
  }

  function updateCartCount(itemCount) {
    getCountElements().forEach((countEl) => {
      countEl.textContent = itemCount;
      countEl.hidden = itemCount <= 0;
    });
  }

  function formatMoney(cents = 0, currencyCode = 'USD') {
    if (!formatterCache.has(currencyCode)) {
      formatterCache.set(
        currencyCode,
        new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode
        })
      );
    }

    return formatterCache.get(currencyCode).format((Number(cents) || 0) / 100);
  }

  async function parseJsonResponse(response, fallbackMessage) {
    let payload = null;

    try {
      payload = await response.json();
    } catch (error) {
      if (!response.ok) {
        throw new Error(fallbackMessage);
      }

      return null;
    }

    if (!response.ok) {
      const message =
        payload?.description ||
        payload?.message ||
        payload?.errors?.join?.(', ') ||
        fallbackMessage;

      throw new Error(message);
    }

    return payload;
  }

  async function getCart() {
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    return parseJsonResponse(response, 'Unable to load cart');
  }

  function dispatchCartUpdating(detail = {}) {
    document.dispatchEvent(
      new CustomEvent('cart:updating', {
        detail
      })
    );
  }

  function dispatchCartSettled(detail = {}) {
    document.dispatchEvent(
      new CustomEvent('cart:update-settled', {
        detail
      })
    );
  }

  function dispatchCartUpdated(cart, source = 'unknown') {
    if (!cart) return null;

    updateCartCount(cart.item_count || 0);

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart,
          source
        }
      })
    );

    return cart;
  }

  async function syncCart(source = 'sync') {
    const cart = await getCart();
    return dispatchCartUpdated(cart, source);
  }

  async function changeLine(line, quantity) {
    dispatchCartUpdating({
      source: 'change',
      line,
      quantity
    });

    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line,
          quantity
        })
      });

      const cart = await parseJsonResponse(response, 'Unable to update cart');
      return dispatchCartUpdated(cart, 'change');
    } finally {
      dispatchCartSettled({
        source: 'change',
        line,
        quantity
      });
    }
  }

  async function addItems(formData) {
    dispatchCartUpdating({
      source: 'add'
    });

    try {
      const addResponse = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      });

      const addedItem = await parseJsonResponse(addResponse, 'Unable to add item to cart');
      const cart = await syncCart('add');

      return {
        addedItem,
        cart
      };
    } finally {
      dispatchCartSettled({
        source: 'add'
      });
    }
  }

  window.HohoCartCore = {
    root,
    formatMoney,
    getCart,
    syncCart,
    changeLine,
    addItems,
    updateCartCount,
    dispatchCartUpdated,
    dispatchCartUpdating,
    dispatchCartSettled
  };
})();